const assertValidDateParts = (year: number, month: number, day: number) => {
  const date = new Date(year, month - 1, day);
  return (
    date.getFullYear() === year &&
    date.getMonth() === month - 1 &&
    date.getDate() === day
  );
};

export const parseBirthdateForDatabase = (value: string): string => {
  const trimmedValue = value.trim();

  if (!trimmedValue) {
    throw new Error("Geburtsdatum erforderlich");
  }

  const germanDateMatch = /^(\d{1,2})\.(\d{1,2})\.(\d{4})$/.exec(trimmedValue);
  if (germanDateMatch) {
    const [, dayValue, monthValue, yearValue] = germanDateMatch;
    const day = Number(dayValue);
    const month = Number(monthValue);
    const year = Number(yearValue);

    if (!assertValidDateParts(year, month, day)) {
      throw new Error("Ungültiges Geburtsdatum");
    }

    return `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
      2,
      "0"
    )}`;
  }

  const isoDateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(trimmedValue);
  if (isoDateMatch) {
    const [, yearValue, monthValue, dayValue] = isoDateMatch;
    const year = Number(yearValue);
    const month = Number(monthValue);
    const day = Number(dayValue);

    if (!assertValidDateParts(year, month, day)) {
      throw new Error("Ungültiges Geburtsdatum");
    }

    return trimmedValue;
  }

  throw new Error("Ungültiges Geburtsdatum");
};
